"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTheme = exports.useTheme = exports.ThemeProvider = void 0;
const react_1 = __importDefault(require("react"));
const styleComponent_1 = require("./styleComponent");
/** Provider for the theme. */
const ThemeProvider = ({ theme, children }) => {
    return react_1.default.createElement(styleComponent_1.SharedValue.Provider, { value: theme }, children);
};
exports.ThemeProvider = ThemeProvider;
/**
 * Returns the Theme
 * @returns The Theme object
 */
const useTheme = () => react_1.default.useContext(styleComponent_1.SharedValue);
exports.useTheme = useTheme;
/**
 * Adds the theme prop to a non rn-css component
 * @param Component A non rn-css component
 * @returns A component with the theme prop
 */
const withTheme = (Component) => {
    const ThemedComponent = react_1.default.forwardRef((props, ref) => {
        const theme = (0, exports.useTheme)();
        return react_1.default.createElement(Component, { ref: ref, theme: theme, ...props });
    });
    ThemedComponent.displayName = 'ThemedComponent';
    return ThemedComponent;
};
exports.withTheme = withTheme;
